const zntAndPre = 'com.dbn.OAConnect';
const zntAndIos = 'OAConnectStore';
function isOAC() {
  const idx = navigator.userAgent.indexOf(zntAndPre);
  if (idx === -1) {
    return false;
  }
  return true;
}
function isIos() {
  const idx = navigator.userAgent.indexOf(zntAndIos);
  if (idx === -1) {
    return false;
  }
  return true;
}
export default function isInZnt() {
  return isOAC() || isIos();
}
